import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { PositionType } from '@antv/l7-core';
import { DOM } from '@antv/l7-utils';
import Control from "./baseControl/control";
export { MouseLocation };

var MouseLocation = /*#__PURE__*/function (_Control) {
  _inherits(MouseLocation, _Control);

  var _super = _createSuper(MouseLocation);

  function MouseLocation() {
    var _this;

    _classCallCheck(this, MouseLocation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "location", [0, 0]);

    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (e) {
      var position = _this.location;
      var lngLat = e.lngLat || e.lnglat;
      var transform = _this.controlOption.transform;

      if (lngLat) {
        position = [lngLat.lng, lngLat.lat];
      }

      _this.location = position;

      if (transform) {
        position = transform(position);
      }

      _this.insertLocation2HTML(position);

      _this.emit('locationChange', position);
    });

    return _this;
  }

  _createClass(MouseLocation, [{
    key: "getLocation",
    value: function getLocation() {
      return this.location;
    }
  }, {
    key: "getDefault",
    value: function getDefault(option) {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(MouseLocation.prototype), "getDefault", this).call(this, option)), {}, {
        position: PositionType.BOTTOMLEFT,
        transform: function transform(_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              lng = _ref2[0],
              lat = _ref2[1];

          return [+(+lng).toFixed(6), +(+lat).toFixed(6)];
        }
      });
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      var container = DOM.create('div', 'l7-control-mouse-location');
      container.innerHTML = '&nbsp;';
      this.mapsService.on('mousemove', this.onMouseMove);
      return container;
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      this.mapsService.off('mousemove', this.onMouseMove);
    }
  }, {
    key: "insertLocation2HTML",
    value: function insertLocation2HTML(position) {
      this.container.innerText = position.join(', ');
    }
  }]);

  return MouseLocation;
}(Control);

export { MouseLocation as default };